import { IConfirmableInjectedAction } from '../../../interfaces';

export class InjectedManageTags implements IConfirmableInjectedAction {
  performActionAfterConfirm = (formData, bindObj, action) => {
    bindObj.worklist.refreshWorklist(
      bindObj.worklist,
      { manualTags: formData.data.manualTags },
      action.rowData.WorkflowRequest['revisions_-1_status'],
      formData.data.meta,
      action.rowData.id
    );
  }
}
